import { render, staticRenderFns } from "./AidocIndex.vue?vue&type=template&id=e8781278&scoped=true"
import script from "./AidocIndex.vue?vue&type=script&lang=js"
export * from "./AidocIndex.vue?vue&type=script&lang=js"
import style0 from "./AidocIndex.vue?vue&type=style&index=0&id=e8781278&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8781278",
  null
  
)

export default component.exports